import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { CButton, Grid, H3, CPage } from "@appcues/component-library";
import SegmentCard from "components/SegmentsIndex/SegmentCard";
import LifecycleSegments from "components/SegmentsIndex/LifecycleSegments";
import IndexPage from "components/Common/IndexPage";
import EmptyState from "components/Common/EmptyState";
import Loader from "components/Common/Loader";
import CoolTip from "components/Common/CoolTip";
import { ACCOUNT_PERMISSIONS } from "constants/accountManagement/permissions";
import {
  selectAccountSegmentsDigest,
  selectAccountSegmentsSynced
} from "reducers/account/segments";
import { selectUserRole } from "reducers/account/users";
import { selectUserId } from "reducers/user";
import { callApi as fetchAllSegmentMemberships } from "actions/account/segmentMemberships";

import WeeklyActiveUserBanner from "./WeeklyActiveUserBanner";
import RecalculateMembershipsButton from "./RecalculateMembershipsButton";

export class SegmentsIndex extends Component {
  componentDidMount() {
    this.props.onLoad();
  }

  CreateButton = ({ cannotCreateSegment }) => {
    const baseCreateButton = (
      <CButton
        isDisabled={cannotCreateSegment}
        is={Link}
        type="positive"
        to="/segments/new/edit"
        className="create-segment"
      >
        Create a Segment
      </CButton>
    );

    if (cannotCreateSegment) {
      return (
        <CoolTip
          tip="Contact a team admin or publisher to create new segments."
          position="bottom"
          marginRight={36}
        >
          {baseCreateButton}
        </CoolTip>
      );
    }
    return baseCreateButton;
  };

  render() {
    const { className, loaded, segments, disableCreate } = this.props;

    if (!loaded) {
      return <Loader />;
    }

    const nonLifecycleSegments = Object.values(segments).filter(
      ({ meta = {} }) => !meta.userLifecycleStage
    );

    return (
      <IndexPage
        className={className}
        title="Segments"
        subHeaderActions={
          <React.Fragment>
            <RecalculateMembershipsButton />
            <this.CreateButton disabled={disableCreate} />
          </React.Fragment>
        }
      >
        <CPage.Container>
          <WeeklyActiveUserBanner />
          <LifecycleSegments segments={segments} />
          <H3 marginBottom={25} lineHeight="40px">
            Your segments
          </H3>
          {nonLifecycleSegments.length > 0 ? (
            <Grid>
              {nonLifecycleSegments.map(({ id }) => (
                <SegmentCard segmentId={id} key={id} />
              ))}
            </Grid>
          ) : (
            <EmptyState
              iconName="users"
              header="No segments yet!"
              body="Create a segment above, or save one from your flow settings."
            />
          )}
        </CPage.Container>
      </IndexPage>
    );
  }
}

function mapStateToProps(state) {
  const role = selectUserRole(state, selectUserId(state));
  return {
    loaded: selectAccountSegmentsSynced(state),
    segments: selectAccountSegmentsDigest(state),
    disableCreate: role === ACCOUNT_PERMISSIONS.EDITOR
  };
}

const mapDispatchToProps = {
  onLoad: fetchAllSegmentMemberships
};

export default connect(mapStateToProps, mapDispatchToProps)(SegmentsIndex);
